'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertsWrapperStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  positionX: _propTypes2.default.oneOf(['left', 'right']),
  positionY: _propTypes2.default.oneOf(['top', 'bottom'])
};
var defaultProps = {
  positionX: 'right',
  positionY: 'bottom'
};

var position = function position(_ref) {
  var themeFromProvider = _ref.theme,
      positionX = _ref.positionX,
      positionY = _ref.positionY;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var oppositePosY = positionY === 'top' ? 'bottom' : 'top';
  var _theme$reactackle$com = theme.reactackle.components.alertsArea.wrapper,
      marginX = _theme$reactackle$com.marginX,
      marginY = _theme$reactackle$com.marginY,
      zIndex = _theme$reactackle$com.zIndex,
      itemsSpacing = _theme$reactackle$com.itemsSpacing;
  return (0, _styledComponents.css)(['margin:', ' ', ';z-index:', ';', ':0;', ':0;', ':auto;& > * + *{margin-top:', ';}'], (0, _reactackleCore.getValueString)(marginY), (0, _reactackleCore.getValueString)(marginX), zIndex, positionX, positionY, oppositePosY, (0, _reactackleCore.getValueString)(itemsSpacing));
};

var AlertsWrapperStyled = exports.AlertsWrapperStyled = _styledComponents2.default.div.withConfig({
  displayName: 'AlertsWrapperStyled'
})(['position:fixed;right:0;display:flex;', ''], position);

AlertsWrapperStyled.propTypes = propTypes;
AlertsWrapperStyled.defaultProps = defaultProps;